import { useAllSchemeGiftItems } from "http-hooks/schmitemaster/useSchemeGiftItem";
import DeleteSchemeGiftItem from "components/schmitemaster/DeleteSchemeGiftItem";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  schmitemname: "",
  ag_status: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "schmitemname", header: "Item Name" },
  { key: "schm_value", header: "Item Value" },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function SchemeGiftItemMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("schmitemaster", id);

  const handleItemSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, schmitemname: searchTerm, page: 1 }));
  };

  const handleStatusChange = (statusOption) => {
    setSelectedStatus(statusOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: statusOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allItems, page: currentPage, totalPages } = [],
  } = useAllSchemeGiftItems(filter);

  return (
    <MasterPage
      title="Scheme Gift Item Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>
          Add Scheme Gift Item
        </AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleItemSearch}
              label="Item Name"
              placeholder="Search Item Name"
            />
          </FilterCell>
          <FilterCell>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              options={statusOptions}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allItems}
      isLoading={isLoading}
      rowKey="schmitemId"
      deleteComponent={DeleteSchemeGiftItem}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.schmitemId)}
            title="Edit Scheme Gift Item"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.schmitemId)}
            title="Delete Scheme Gift Item"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
